import { Injectable } from '@angular/core';
import { IssueSupplier } from '@arpada/arp-lib-common-qupro';
import { IssueFront, OperatorFront, IssuePriorityFront, IssueStateGroupFront, RowModel, InputsToUpdate } from '../../models/api.models';


@Injectable({
  providedIn: 'root'
})
export class IssuePopulateService {

  constructor() { }

  public convertirIssuesToReviewPresaleFront(issues: IssueSupplier[]): IssueFront[] {
    const issuesFront: IssueFront[] = [];
    issues.forEach(issue => {
      const issueFront = new IssueFront();
      issueFront.id = issue.id;
      issueFront.issuePriority = new IssuePriorityFront();
      issueFront.issuePriority.priority = issue.priority.toLowerCase();
      issueFront.portal = issue.portal;
      issueFront.floor = issue.floor;
      issueFront.letter = issue.letter;
      issueFront.issueStateGroup = new IssueStateGroupFront();
      issueFront.issueStateGroup.stateGroup = issue.state_group_name;
      issueFront.issueStateGroup.stateGroupKey = issue.state_group_key;
      issueFront.name = issue.name;
      issueFront.location_name = issue.location_name;
      issueFront.create_date = issue.create_date;
      issueFront.postsale_manager_comment = issue.postsale_manager_comment;
      issueFront.has_proforma = issue.has_proforma;
      issueFront.operatorFront = new OperatorFront();
      issueFront.operatorFront.operario = 'Operario ' + issue.operator_num;
      issueFront.operatorFront.claseOperario = 'operario' + issue.operator_num;
      issueFront.operatorFront.id = issue.operator_num;
      issueFront.supplier_actions = issue.supplier_actions;
      issueFront.csite_id = issue.csite_id;
      issueFront.csite_name = issue.csite_name;
      issueFront.csite_internal_number = issue.csite_internal_number;
      issueFront.house_id = issue.house_id;
      issueFront.supplier_partner_assignment_date = issue.supplier_partner_assignment_date;
      issuesFront.push(issueFront);
      // issuesFront = [...this.issueFronts]; // refresh data si no no pinta los datos parseados
    });
    return issuesFront;
  }

  public convertirIssueToReviewPresaleFront(issue: IssueSupplier): IssueFront {
    const issueFront = new IssueFront();
    issueFront.id = issue.id;
    issueFront.issuePriority = new IssuePriorityFront();
    issueFront.issuePriority.priority = issue.priority.toLowerCase();
    issueFront.portal = issue.portal;
    issueFront.floor = issue.floor;
    issueFront.letter = issue.letter;
    issueFront.issueStateGroup = new IssueStateGroupFront();
    issueFront.issueStateGroup.stateGroup = issue.state_group_name;
    issueFront.issueStateGroup.stateGroupKey = issue.state_group_key;
    issueFront.name = issue.name;
    issueFront.location_name = issue.location_name;
    issueFront.create_date = issue.create_date;
    issueFront.postsale_manager_comment = issue.postsale_manager_comment;
    issueFront.has_proforma = issue.has_proforma;
    issueFront.operatorFront = new OperatorFront();
    issueFront.operatorFront.operario = 'Operario ' + issue.operator_num;
    issueFront.operatorFront.claseOperario = 'operario' + issue.operator_num;
    issueFront.operatorFront.id = issue.operator_num;
    issueFront.supplier_actions = issue.supplier_actions;
    issueFront.csite_id = issue.csite_id;
    issueFront.csite_name = issue.csite_name;
    issueFront.csite_internal_number = issue.csite_internal_number;
    issueFront.house_id = issue.house_id;
    issueFront.supplier_partner_assignment_date = issue.supplier_partner_assignment_date;
    return issueFront;
  }

  public convertirIssuesToPostsaleFrontIssues(issues: IssueSupplier[]): IssueFront[] {
    const issuesFront: IssueFront[] = [];
    issues.forEach(issue => {
      const issueFront = new IssueFront();
      issueFront.id = issue.id;
      issueFront.issuePriority = new IssuePriorityFront();
      issueFront.issuePriority.priority = issue.priority.toLowerCase();
      issueFront.portal = issue.portal;
      issueFront.floor = issue.floor;
      issueFront.letter = issue.letter;
      issueFront.issueStateGroup = new IssueStateGroupFront();
      issueFront.issueStateGroup.stateGroup = issue.state_group_name;
      issueFront.issueStateGroup.stateGroupKey = issue.state_group_key;
      issueFront.name = issue.name;
      issueFront.location_name = issue.location_name;
      issueFront.create_date = issue.create_date;
      issueFront.appointment_date = issue.appointment_date;
      issueFront.material = issue.material;
      issueFront.material_date = issue.material_date;
      issueFront.repair_date = issue.repair_date;
      issueFront.supplier_comment = issue.supplier_comment;
      issueFront.has_agreement = issue.has_agreement;
      issueFront.has_proforma = issue.has_proforma;
      issueFront.operatorFront = new OperatorFront();
      issueFront.operatorFront.operario = 'Operario ' + issue.operator_num;
      issueFront.operatorFront.claseOperario = 'operario' + issue.operator_num;
      issueFront.operatorFront.id = issue.operator_num;
      issueFront.supplier_actions = issue.supplier_actions;
      issueFront.csite_id = issue.csite_id;
      issueFront.csite_name = issue.csite_name;
      issueFront.csite_internal_number = issue.csite_internal_number;
      issueFront.supplier_actions = issue.supplier_actions;
      issueFront.owner_conform = issue.owner_conform;
      issueFront.contact_firstname = issue.contact_firstname;
      issueFront.contact_lastname = issue.contact_lastname;
      issueFront.contact_phone = issue.contact_phone;
      issueFront.contact_email = issue.contact_email;
      issueFront.last_supplier_comment = issue.last_supplier_comment;
      issueFront.house_id = issue.house_id;
      issueFront.supplier_partner_assignment_date = issue.supplier_partner_assignment_date;
      issuesFront.push(issueFront);
      // issuesFront = [...this.issueFronts]; // refresh data si no no pinta los datos parseados
    });
    return issuesFront;
  }

  public convertirIssueSupplierToPostsaleFrontIssue(issue: IssueSupplier): IssueFront {

    const issueFront = new IssueFront();
    issueFront.id = issue.id;
    issueFront.issuePriority = new IssuePriorityFront();
    issueFront.issuePriority.priority = issue.priority.toLowerCase();
    issueFront.portal = issue.portal;
    issueFront.floor = issue.floor;
    issueFront.letter = issue.letter;
    issueFront.issueStateGroup = new IssueStateGroupFront();
    issueFront.issueStateGroup.stateGroup = issue.state_group_name;
    issueFront.issueStateGroup.stateGroupKey = issue.state_group_key;
    issueFront.name = issue.name;
    issueFront.location_name = issue.location_name;
    issueFront.create_date = issue.create_date;
    issueFront.appointment_date = issue.appointment_date;
    issueFront.material = issue.material;
    issueFront.material_date = issue.material_date;
    issueFront.repair_date = issue.repair_date;
    issueFront.supplier_comment = issue.supplier_comment;
    issueFront.has_agreement = issue.has_agreement;
    issueFront.has_proforma = issue.has_proforma;
    issueFront.operatorFront = new OperatorFront();
    issueFront.operatorFront.operario = 'Operario ' + issue.operator_num;
    issueFront.operatorFront.claseOperario = 'operario' + issue.operator_num;
    issueFront.operatorFront.id = issue.operator_num;
    issueFront.supplier_actions = issue.supplier_actions;
    issueFront.csite_id = issue.csite_id;
    issueFront.csite_name = issue.csite_name;
    issueFront.csite_internal_number = issue.csite_internal_number;
    issueFront.owner_conform = issue.owner_conform;
    issueFront.last_supplier_comment = issue.last_supplier_comment;
    issueFront.house_id = issue.house_id;
    return issueFront;
  }

  public convertFrontIssuesToIssueSupplier(frontIssues: IssueFront[], issues: IssueSupplier[]): IssueSupplier[] {
    const listToEdit: IssueSupplier[] = [];
    frontIssues.forEach(issueFront => {
      issues.forEach(issue => {
        if (issueFront.id === issue.id) {
          listToEdit.push(issue);
        }
      });
    });
    return listToEdit;
  }

  public convertirIssuesSupplierToIssuesProformablesFront(issues: IssueSupplier[]): IssueFront[] {
    let issuesFront: IssueFront[] = [];
    issuesFront = [];
    issues.forEach(issue => {
      const issueFront = new IssueFront();
      issueFront.id = issue.id;
      issueFront.portal = issue.portal;
      issueFront.floor = issue.floor;
      issueFront.letter = issue.letter;
      issueFront.issueStateGroup = new IssueStateGroupFront();
      issueFront.issueStateGroup.stateGroup = issue.state_group_name;
      issueFront.issueStateGroup.stateGroupKey = issue.state_group_key;
      issueFront.name = issue.name;
      issueFront.location_name = issue.location_name;
      issueFront.supplier_actions = issue.supplier_actions;
      issueFront.csite_id = issue.csite_id;
      issueFront.csite_name = issue.csite_name;
      issueFront.csite_internal_number = issue.csite_internal_number;
      issueFront.has_agreement = issue.has_agreement;
      issueFront.house_id = issue.house_id;
      issueFront.material_cost = issue.material_cost;
      issueFront.labor_cost = issue.labor_cost;
      issueFront.b_requiere_presupuesto_aprobado = issue.b_requiere_presupuesto_aprobado;
      issuesFront.push(issueFront);
      // issuesFront = [...this.issueFronts]; // refresh data si no no pinta los datos parseados
    });
    return issuesFront;
  }

  public convertirIssueSupplierToIssueProformableFront(issue: IssueSupplier): IssueFront {
    const issueFront = new IssueFront();
    issueFront.id = issue.id;
    issueFront.portal = issue.portal;
    issueFront.floor = issue.floor;
    issueFront.letter = issue.letter;
    issueFront.issueStateGroup = new IssueStateGroupFront();
    issueFront.issueStateGroup.stateGroup = issue.state_group_name;
    issueFront.issueStateGroup.stateGroupKey = issue.state_group_key;
    issueFront.name = issue.name;
    issueFront.location_name = issue.location_name;
    issueFront.supplier_actions = issue.supplier_actions;
    issueFront.csite_id = issue.csite_id;
    issueFront.csite_name = issue.csite_name;
    issueFront.csite_internal_number = issue.csite_internal_number;
    issueFront.has_agreement = issue.has_agreement;
    issueFront.house_id = issue.house_id;
    return issueFront;
  }

  public convertFrontIssueToIssueSupplier(issueFront: IssueFront): IssueSupplier {
    const issueSuplier: IssueSupplier = new IssueSupplier();
    issueSuplier.id = issueFront.id;
    issueSuplier.name = issueFront.name;
    issueSuplier.job_name = issueFront.job_name;
    issueSuplier.job_id = issueFront.job_id;
    issueSuplier.location_name = issueFront.location_name;
    issueSuplier.location_id = issueFront.location_id;
    issueSuplier.state_comment = issueFront.state_comment;
    issueSuplier.state_key = issueFront.state_key;
    issueSuplier.state_group_name = issueFront.state_group_name;
    issueSuplier.state_group_key = issueFront.state_group_key;
    issueSuplier.state_name = issueFront.state_name;
    issueSuplier.phase_key = issueFront.phase_key;
    issueSuplier.phase_name = issueFront.phase_name;
    issueSuplier.appointment_date = issueFront.appointment_date;
    issueSuplier.create_date = issueFront.create_date;
    issueSuplier.material_date = issueFront.material_date;
    issueSuplier.material = issueFront.material;
    issueSuplier.repair_date = issueFront.repair_date;
    issueSuplier.owner_comment = issueFront.owner_comment;
    issueSuplier.postsale_admin_comment = issueFront.postsale_admin_comment;
    issueSuplier.postsale_manager_comment = issueFront.postsale_manager_comment;
    issueSuplier.postsale_technician_comment = issueFront.postsale_technician_comment;
    issueSuplier.property_developer_comment = issueFront.property_developer_comment;
    issueSuplier.supplier_comment = issueFront.supplier_comment;
    issueSuplier.has_photo = issueFront.has_photo;
    issueSuplier.has_agreement = issueFront.has_agreement;
    issueSuplier.has_proforma = issueFront.has_proforma;
    issueSuplier.contact_email = issueFront.contact_email;
    issueSuplier.contact_firstname = issueFront.contact_firstname;
    issueSuplier.contact_lastname = issueFront.contact_lastname;
    issueSuplier.contact_phone = issueFront.contact_phone;
    issueSuplier.house_id = issueFront.house_id;
    issueSuplier.common_area = issueFront.common_area;
    issueSuplier.portal = issueFront.portal;
    issueSuplier.floor = issueFront.floor;
    issueSuplier.letter = issueFront.letter;
    issueSuplier.priority = issueFront.priority;
    issueSuplier.priority_color = issueFront.priority_color;
    issueSuplier.operator_num = issueFront.operator_num;
    issueSuplier.supplier_actions = issueFront.supplier_actions;
    issueSuplier.csite_id = issueFront.csite_id;
    issueSuplier.csite_name = issueFront.csite_name;
    issueSuplier.csite_internal_number = issueFront.csite_internal_number;
    issueSuplier.house_id = issueFront.house_id;
    return issueSuplier;
  }

  public createRowsModelToUpdate(issuesFront: IssueFront[]): RowModel[] {
    const rowsModel: RowModel[] = [];
    issuesFront.forEach((issueFront: IssueFront, index) => {
      const rowModel: RowModel = new RowModel();
      const frontInputsToUpdate: InputsToUpdate = new InputsToUpdate();
      rowModel.rowIndex = index;
      frontInputsToUpdate.appointment_date = this.getFormatDate(issueFront.appointment_date);
      frontInputsToUpdate.material_date = this.getFormatDate(issueFront.material_date);
      frontInputsToUpdate.repair_date = this.getFormatDate(issueFront.repair_date);
      frontInputsToUpdate.supplier_comment = issueFront.supplier_comment;
      frontInputsToUpdate.operator_num = issueFront.operatorFront.id;
      rowModel.frontInputsToUpdate = frontInputsToUpdate;
      rowsModel.push(rowModel);
    });
    return rowsModel;
  }

  public getFormatDate(issueFrontDate): string {
    let fecha: string = null;
    if (typeof issueFrontDate !== 'undefined') {
      fecha = this.getStringOfTimestamp(+issueFrontDate);
    } else {
      fecha = this.getStringOfTimestamp(0);
    }
    return fecha;
  }

  public isIssueFrontProformable(issueFront: IssueFront): boolean {
    if (issueFront.has_agreement !== 0) {
      return true;
    } else {
      return false;
    }
  }

  getStringOfTimestamp(timestamp: number): string {
    let toReturn: string = null;
    if (timestamp) {
      toReturn = new Date(timestamp).toISOString();
      // formatDate( timestamp, 'YYYY-MM-DDThh:mm:ss.sTZD', 'es', '+0100');
    }
    return toReturn;
  }

}
